import httpInProgressActionTypes from '../constants/action-types';

export const handleHttpInProgress = inProgress => {
  return {
    type: httpInProgressActionTypes.HANDLE_HTTP_IN_PROGRESS,
    data: inProgress,
  };
};



// WEBPACK FOOTER //
// ./src/app/shared/http-in-progress/actions/http-in-progress-actions.js